import { create } from 'zustand'
import { DEMO_EMPLOYEE_ID, getMonday, toIsoDate } from '../services/timesheetDataService'

interface TimesheetState {
  currentEmployeeId: string
  setCurrentEmployeeId: (id: string) => void

  weekStart: string
  setWeekStart: (d: string) => void
  prevWeek: () => void
  nextWeek: () => void

  pendingCount: number
  setPendingCount: (n: number) => void
}

// Persist the picked persona so a refresh keeps the active employee instead of
// snapping back to the DEMO_EMPLOYEE_ID default. Demo-only impersonation state;
// safe to keep in localStorage.
const EMPLOYEE_ID_KEY = 'ppm-timesheet-employee-id'

function loadPersistedEmployeeId(): string {
  try {
    const stored = localStorage.getItem(EMPLOYEE_ID_KEY)
    if (stored) return stored
  } catch { /* ignore disabled storage */ }
  return DEMO_EMPLOYEE_ID
}

export const useTimesheetStore = create<TimesheetState>((set, get) => ({
  currentEmployeeId: loadPersistedEmployeeId(),
  setCurrentEmployeeId: (id) => {
    try { localStorage.setItem(EMPLOYEE_ID_KEY, id) } catch { /* ignore */ }
    set({ currentEmployeeId: id })
  },

  weekStart: toIsoDate(getMonday(new Date())),
  setWeekStart: (d) => set({ weekStart: d }),
  prevWeek: () => {
    const d = new Date(get().weekStart)
    d.setDate(d.getDate() - 7)
    set({ weekStart: toIsoDate(d) })
  },
  nextWeek: () => {
    const d = new Date(get().weekStart)
    d.setDate(d.getDate() + 7)
    set({ weekStart: toIsoDate(d) })
  },

  pendingCount: 2,
  setPendingCount: (n) => set({ pendingCount: n }),
}))
